import { Formik, Form } from "formik";
import * as Yup from "yup";
import MultipleEmailInput from "../../../../components/multipleEmailInput/MultipleEmailInput";
import { BackButton, Submit } from "../../../../components/button/buttons";
import styles from './addEmail.module.css'
import { useState } from "react";
import IMAGES from "../../../../assets/images/images";

const EmailContainer = ({ emailData, submitEmail,getDetail,id,myRights, setIsHidden, isRequestor, ishidden,...props }) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const initialValues = {
    additionalEmails: emailData || [],
  };

  const validationSchema = Yup.object({
    additionalEmails: Yup.array()
      .of(
        Yup.string()
          .trim()
          .email("Please enter a valid email address.")
      )
      .test(
        "not-requestor-email",
        "Requestor email is not allowed.",
        function (emails) {
          if (!emails || !myRights?.email) return true;

          return !emails.some(
            (email) =>
              email?.toLowerCase() === myRights.email?.toLowerCase()
          );
        }
      ),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmit(true);
    const payload = { additionalEmails: values.additionalEmails};
    submitEmail(payload, id).then((result) => {
      if (result.status) {
        getDetail(id)
        resetForm();
        setIsHidden(false)
        setIsSubmit(false);
         props.openAlertPopup({
              message: "Emails updated successfully!",
              image: IMAGES.success
            });
      } else {
        setIsSubmit(false);
      }
    })
      .catch((error) => {
        setIsSubmit(false);
      });
  };

  let note = "The email addresses listed here were added by the ticket requester during ticket creation and will receive all ticket updates, status change notifications, and related communications."

  return (
    <div>
      <div className={styles.emailSection}>
        <div className={styles.header}>Additional Emails</div>
        {!ishidden && isRequestor ? <div><span onClick={() => setIsHidden(true)} className={styles.editbtn}>Edit Recipients</span></div> : <></>}
      </div>
      {!ishidden ?
        <div className={styles.emailcontainor}>
          <div className={styles.displayWrapper}>
            <div className={styles.notetxt}>{note}</div>
            <div className={styles.emailValue}>
              {initialValues?.additionalEmails?.length > 0 ? (
                initialValues?.additionalEmails?.map((email, index) => (
                  <span key={index} className={styles.emailChip}>
                    {email}
                  </span>
                ))) : (<span className={styles.emptyEmail}>Email Not Added</span>)}
            </div>
          </div>
        </div> :
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          validateOnChange
          validateOnBlur
          onSubmit={handleSubmit}
        >
          {({ isValid, dirty }) => (<>
            <div className={styles.formWrapper}>
              <div className={styles.notetxt}>{note}</div>
              <div className={styles.formContainer}>
                <Form className={styles.form} id="email_form">
                  <div className={styles.emailcontainors}>
                    <MultipleEmailInput
                      name="additionalEmails"
                      // label="Additional Emails"
                      isPreviewMode={false}
                      requestorEmail={myRights?.email}
                      showTooltip={false}
                      isNote={false}
                      maxWidth={"detailStyle"}
                      tooltipText="Additional Emails"
                    />
                  </div>
                </Form>

                <div className={styles.footer}>
                  <div className={styles.buttonContainer}>
                    <BackButton
                      className={styles.backButton}
                      title="Cancel"
                      closePopup={() => setIsHidden(false)}
                      disabled={isSubmit}
                    // onClick={()=>setIsHidden(false)}
                    />

                    <Submit
                      id="saveButton"
                      className={styles.saveButton}
                      title="Save Changes"
                      disabled={!isValid || !dirty}
                      form="email_form"
                      loaderstyle={styles.loaderstyle}
                      isSubmitting={isSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>)}
        </Formik>}
    </div>
  );
};
export default EmailContainer;